import { createContext } from "react";
import type { IBrazilianRealEstateFundTopLevelFragment } from "../../lib/fragments/__generated__/BrazilianRealEstateFundTopLevel.generated";

const BrazilianRealEstateFundContext = createContext<IBrazilianRealEstateFundTopLevelFragment | null>(null);

export default BrazilianRealEstateFundContext;
